import { render } from "./AdminOrderList.vue?vue&type=template&id=48aebcd8"
import script from "./AdminOrderList.vue?vue&type=script&lang=js"
export * from "./AdminOrderList.vue?vue&type=script&lang=js"
script.render = render

export default script